import { render, staticRenderFns } from "./credit.vue?vue&type=template&id=39a6e18c&scoped=true&"
import script from "./credit.vue?vue&type=script&lang=js&"
export * from "./credit.vue?vue&type=script&lang=js&"
import style0 from "./credit.vue?vue&type=style&index=0&id=39a6e18c&scoped=true&lang=css&"
import style1 from "./credit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a6e18c",
  null
  
)

export default component.exports